import { useEffect, useState } from 'react';
import './text-area.css';

function TextArea({
    rows,
    cols,
    className,
    placeholder,
    disable,
    shouldValidate = false,
    onChange = () => {},
    value,
    onValidate = () => {},
    maxLength,
    warningMsg
}) {
    const [invalidValue, setInvalidValue] = useState(false);
    const [currentValue, setCurrentValue] = useState(value ?? '');

    useEffect(() => {
        if (shouldValidate)
            setInvalidValue(!onValidate());

    }, [shouldValidate, onValidate]);

    useEffect(() => {
        setCurrentValue(value ?? '');
    }, [value]);

    return (
        <div className='textarea-container'>
            <textarea
                rows={rows}
                cols={cols}
                className={className}
                placeholder={placeholder}
                disabled={disable}
                onChange={(e) => {
                    setInvalidValue(false);
                    setCurrentValue(e.target.value);
                    onChange(e);
                }}
                onBlur={() => setInvalidValue(!onValidate())}
                maxLength={maxLength}
                value={currentValue}
            >
            </textarea>

            <span className='textarea-count'>
                {currentValue.length}{maxLength ? `/${maxLength}` : ''}
            </span>

            <span className={`textarea-warning-msg ${invalidValue ? 'show' : ''}`}>
                {warningMsg}
            </span>
        </div>
    );
}

export default TextArea;